'use client';

import type { ReactNode } from 'react';
import { Children } from 'react';
import { Button } from '@packages/shared/src/ui/Button/Button';
import { Popover, PopoverContent, PopoverTrigger } from '@packages/shared/src/ui/Popover/Popover';

export interface MoreMenuProps {
  children: ReactNode;
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
}

export const MoreMenu = ({ children, isOpen, onOpenChange }: MoreMenuProps) => {
  /** It will toggle the open state via the onOpenChange prop. */
  const controlMoreMenu = () => onOpenChange(!isOpen);

  return (
    <div className="absolute top-0 right-0 h-fit">
      <Popover open={isOpen} onOpenChange={onOpenChange}>
        <PopoverTrigger asChild>
          <Button
            onClick={controlMoreMenu}
            className={`h-5 min-h-5 w-5 border-none p-0 ${isOpen ? 'bg-color-grey-main' : 'bg-color-transparent'}`}
          >
            <div className="icon-emp-menu-android" />
          </Button>
        </PopoverTrigger>
        <PopoverContent align="end" alignOffset={12} className="z-9 w-[11.25rem] px-0 py-1" asChild>
          <ul>
            {Children.map(children, (child) => (
              <li key={child?.toString()} className="p-0">
                {child}
              </li>
            ))}
          </ul>
        </PopoverContent>
      </Popover>
    </div>
  );
};
